<header id="navbar" class="nav">
  <nav class="navbar navbar-expand-lg navbar-dark navbar_top nav_bgcolor w-100">
    <ul
      class="w-100 nav-menu m-auto text-decoration-none menu list-unstyled d-flex d-none d-md-block d-sm-block d-lg-none">
      <li class="w-80 float-left">
        <h4 class="nurul_namemob">NURUL HASSAN</h4>
      </li>
      <li class="w-20 float-right">
        <button #navbarToggler class="navbar-toggler float-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" 
          aria-controls="navbarSupportedContent" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </li>  
    </ul>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5">
            <ul class="navbar-nav mr-auto nav-content">
              <li class="nav-item mx-3 " routerLinkActive="active">
                <a class="nav-menu text-decoration-none" id="nav_link" routerLinkActive="active"
                  routerLink="/home"><span routerLinkActive="navclr">Home</span></a>
              </li>
              <li class="nav-item mx-3" routerLinkActive="active">
                <a class="nav-menu text-decoration-none" id="nav_link" routerLink="/my_skills"><span
                    routerLinkActive="navclr">Skills</span></a>
              </li>
              <li class="nav-item mx-3" routerLinkActive="active">
                <a class="nav-menu text-decoration-none" id="nav_link" routerLink="/about_me"><span
                    routerLinkActive="navclr">About Me</span></a>
              </li>
            </ul>
          </div>

          <div class="col-md-2 d-md-none d-sm-none d-lg-block d-none">
            <h5 class="nurul_name">nurulhassan</h5>
          </div>

          <div class="col-md-5">
            <ul class="navbar-nav mr-auto nav-content">
              <li class="nav-item mx-3" routerLinkActive="active">
                <a class="nav-menu text-decoration-none" id="nav_link" routerLink="/carrier"><span
                    routerLinkActive="navclr">Carrier</span></a>
              </li>
              <li class="nav-item mx-3" routerLinkActive="active">
                <a class="nav-menu text-decoration-none" id="nav_link" routerLink="/my_work"><span
                    routerLinkActive="navclr">Work</span></a>
              </li>
              <li class="nav-item mx-3" routerLinkActive="active">
                <a class="nav-menu text-decoration-none" id="nav_link" routerLink="/contact_me"><span
                    routerLinkActive="navclr">Contact Me</span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>